import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { ActionItemType } from '../types';

export const INITIAL_SELECTED_ACTION_ITEM: ActionItemType = ActionItemType.CriticalItems;

const selectedActionItemAtom = atomWithStorage<ActionItemType>(
  'selectedActionItem',
  INITIAL_SELECTED_ACTION_ITEM,
  undefined,
  { getOnInit: true },
);

export const useSelectedActionItem = () => useAtom(selectedActionItemAtom);
